import { type FC } from 'react'

import SvgIcon, { type IconProps } from './SvgIcon'

const PATH =
  'M77.122 51.282a3.151 3.151 0 0 0 0-2.407 3.109 3.109 0 0 0-.779-1.091c-.025-.027-.033-.063-.059-.089L52.228 23.639a3.149 3.149 0 0 0-4.454 4.454l18.837 18.836H25.789a3.15 3.15 0 1 0 0 6.3h40.823L47.933 71.907a3.149 3.149 0 1 0 4.454 4.454L76.44 52.308a3.159 3.159 0 0 0 .682-1.026z'

const IconArrowRight: FC<IconProps> = props => (
  <SvgIcon {...props} path={PATH} />
)

export default IconArrowRight
